export default __webpack_public_path__ + "static/badminton-sec2-img-058efb9cb0c427d0db522afd7759aee4.png";